// Swaps the dropdown's card set to the hovered/focused sub-item; falls back to the default set.
if (!customElements.get('menu-hover-cards')) {
  customElements.define(
    'menu-hover-cards',
    class MenuHoverCards extends HTMLElement {
      connectedCallback() {
        // Element is display: contents, so leave is tracked on the dropdown box itself
        this.dropdown = this.parentElement;
        this.onActivate = (event) => {
          const trigger = event.target.closest('[data-menu-cards-trigger]');
          if (trigger && this.contains(trigger)) this.show(trigger);
        };
        this.onReset = () => this.show(null);
        // Touch has no hover: first tap previews a sub-item's cards, tapping it again follows the link
        this.onTap = (event) => {
          const trigger = event.target.closest('[data-menu-cards-trigger]');
          if (!trigger || !this.contains(trigger) || trigger.classList.contains('submenu-item--current')) return;
          if (!this.querySelector(`[data-menu-cards="${CSS.escape(trigger.dataset.menuCardsTrigger)}"]`)) return;
          event.preventDefault();
          this.show(trigger);
        };

        if (this.dataset.mode === 'tap') {
          this.addEventListener('click', this.onTap);
          return;
        }

        this.addEventListener('pointerover', this.onActivate);
        this.addEventListener('focusin', this.onActivate);
        this.dropdown.addEventListener('pointerleave', this.onReset);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onTap);
        this.removeEventListener('pointerover', this.onActivate);
        this.removeEventListener('focusin', this.onActivate);
        this.dropdown?.removeEventListener('pointerleave', this.onReset);
      }

      show(trigger) {
        const key = trigger?.dataset.menuCardsTrigger;
        const panels = this.querySelectorAll('[data-menu-cards]');
        const match = key ? [...panels].find((panel) => panel.dataset.menuCards === key) : null;
        const target = match || [...panels].find((panel) => panel.dataset.menuCards === 'default');

        panels.forEach((panel) => {
          panel.hidden = panel !== target;
        });
        this.querySelectorAll('[data-menu-cards-trigger]').forEach((item) => {
          item.classList.toggle('submenu-item--current', Boolean(match) && item === trigger);
        });
      }
    }
  );
}
